import useReveal from "@/hooks/useReveal";
import { HOME } from "@/constants/testIds";

const TESTIMONIALS = [
  {
    id: "eleanor-marcus",
    quote:
      "Indiora did not plan a trip. They composed a fortnight of small, perfect moments — many of which we still cannot quite believe happened.",
    name: "Eleanor & Marcus W.",
    place: "London — Rajasthan & Bhutan, 2025",
  },
  {
    id: "henrik-vasquez",
    quote:
      "The access, the discretion, the deep cultural literacy — it is unlike anything we have experienced in twenty years of travel.",
    name: "Henrik Vasquez",
    place: "Copenhagen — Kerala & Sri Lanka, 2025",
  },
];

export default function TestimonialsSection() {
  const r = useReveal();
  return (
    <section
      ref={r}
      data-testid={HOME.testimonialsSection}
      className="relative py-32 md:py-40 bg-nightsky text-ivory overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-25 mix-blend-soft-light"
        style={{
          backgroundImage:
            "url('https://static.prod-images.emergentagent.com/jobs/79144187-2235-4ee7-9fa7-a726d5fa0d55/images/ee0826617731e28633def1043fa74b7fe9c94e40a77e7980e7a75dfc35b0424f.png')",
          backgroundSize: "cover",
        }}
      />
      <div className="relative max-w-[1180px] mx-auto px-6 md:px-12">
        <div className="eyebrow-light mb-12">Letters from the Field</div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20">
          {TESTIMONIALS.map((t) => (
            <figure key={t.id} className="border-l-2 border-goldleaf pl-10">
              <blockquote className="font-serif text-2xl md:text-3xl italic font-light leading-[1.35] text-ivory/95">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-8 text-[11px] tracking-widest2 uppercase text-ivory/60">
                {t.name} <span className="text-goldleaf mx-2">·</span> {t.place}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
